import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { Toaster, toast } from 'sonner'
import { AuthProvider } from '@/lib/auth-context'
import { router } from '@/router'
import './index.css'

const STALE_TIME_MS = 30_000

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_MS,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
  mutationCache: new MutationCache({
    onError: (error) => {
      // Show a toast for every mutation error unless the component handles it.
      // ApiClientError.message is already user-friendly (via friendlyMessage).
      const message = error instanceof Error ? error.message : 'Something went wrong'
      toast.error(message)
    },
  }),
})

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
        <Toaster
          position="top-right"
          toastOptions={{
            style: { fontSize: '14px' },
            duration: 5000,
          }}
        />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
